import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useTranslation } from 'react-i18next'

import { httpOk, GET } from 'helpers/api'
import { formatDate, formatMoney } from "helpers/helpers"

function Preview() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { id } = useParams()

	const [data, setData] = useState(null)

	useEffect(() => {
		async function load() {
			const response = await GET(`/inventory/${id}`, {}, { loader: true })
			if (httpOk(response)) setData(response.data)
		}
		load()
	}, [id])

	if (!data) return null

	const totalShortage = (data.elements || [])
		.filter(el => Number(el.divergence) < 0)
		.reduce((s, el) => s + Math.abs(Number(el.difference_amount)), 0)

	const totalSurplus = (data.elements || [])
		.filter(el => Number(el.divergence) > 0)
		.reduce((s, el) => s + Number(el.difference_amount), 0)

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					Inventarizatsiya №{data.document_number}
				</h4>
				<button className="btn btn-outline-secondary" onClick={() => navigate('/inventory')}>
					{t('back')}
				</button>
			</div>

			<div className="card mb-3">
				<div className="card-body">
					<div className="row">
						<div className="col-md-3">
							<div className="text-muted small">Ombor</div>
							<div className="fw-semibold">{data.pos_name}</div>
						</div>
						<div className="col-md-3">
							<div className="text-muted small">Sana</div>
							<div className="fw-semibold">{formatDate(data.created_at, 'dd.MM.yyyy HH:mm')}</div>
						</div>
						<div className="col-md-3">
							<div className="text-muted small">Taqchillik</div>
							<div className="fw-semibold text-danger">{formatMoney(totalShortage)}</div>
						</div>
						<div className="col-md-3">
							<div className="text-muted small">Ortiqcha</div>
							<div className="fw-semibold text-success">{formatMoney(totalSurplus)}</div>
						</div>
						{data.note && (
							<div className="col-12 mt-2">
								<div className="text-muted small">{t('note')}</div>
								<div>{data.note}</div>
							</div>
						)}
					</div>
				</div>
			</div>

			<div className="card">
				<div className="card-body p-0">
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead className="table-light">
								<tr>
									<th>#</th>
									<th>Mahsulot</th>
									<th>O'lchov</th>
									<th className="text-end">Tizim qoldig'i</th>
									<th className="text-end">Haqiqiy miqdor</th>
									<th className="text-end">Farq</th>
									<th className="text-end">Narx</th>
									<th className="text-end">Summa farq</th>
								</tr>
							</thead>
							<tbody>
								{(data.elements || []).map((el, i) => {
									const div = Number(el.divergence)
									const amt = Number(el.difference_amount)
									return (
										<tr key={i}>
											<td>{i + 1}</td>
											<td>{el.name}</td>
											<td>{el.unit_name}</td>
											<td className="text-end">{Number(el.balance).toFixed(2)}</td>
											<td className="text-end">{Number(el.actual_balance).toFixed(2)}</td>
											<td className={`text-end fw-semibold ${div < 0 ? 'text-danger' : div > 0 ? 'text-success' : ''}`}>
												{div > 0 ? '+' : ''}{div.toFixed(2)}
											</td>
											<td className="text-end">{formatMoney(el.price)}</td>
											<td className={`text-end fw-semibold ${amt < 0 ? 'text-danger' : amt > 0 ? 'text-success' : ''}`}>
												{amt !== 0 ? (amt > 0 ? '+' : '') + formatMoney(Math.abs(amt)) : '—'}
											</td>
										</tr>
									)
								})}
							</tbody>
							<tfoot className="table-light fw-bold">
								<tr>
									<td colSpan={7} className="text-end">Taqchillik:</td>
									<td className="text-end text-danger">{formatMoney(totalShortage)}</td>
								</tr>
								<tr>
									<td colSpan={7} className="text-end">Ortiqcha:</td>
									<td className="text-end text-success">{formatMoney(totalSurplus)}</td>
								</tr>
							</tfoot>
						</table>
					</div>
				</div>
			</div>
		</>
	)
}

export default Preview
